import React, { useState } from "react";
import Header from "../../components/Header";
import AdminCointainer from "../../containers/Admin";
import CountCard from "../../components/CounterCard";
import CustomTabs from "../../components/Tab";
import { bookingStatus, bookingTabs, } from '../../common/staticData';
import Carousel from "../../components/Carousel";
import DateTimePicker from "../../components/Date&Time";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import CustomButton from "../../components/AddButton";
import { useNavigate } from "react-router-dom";
import Filter from "../../components/FilterButton";
import Notification from "../Notification";
import ReportButton from "../../components/ReportButton";
import AllBooking from "./components/AllBooking";
import UnderConstruction from "../../components/UnderConstruction/UnderConstruction";
import { booking, Plus } from "../../common/svg";
import BookingDraft from "./components/BookingDraft";
const Booking = () => {
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState<string>("All Bookings");
  // const currentLanguage = useSelector((state: RootState) => state.language.currentLanguage);

  const items = [
    <div className="p-4 bg-gray-100 rounded-lg text-center">
      <h2 className="text-lg font-semibold">Slide 1</h2>
      <p>Loading Point: On the way</p>
    </div>,
  ]
  const handleTabChange = (tab: string) => {
    if (tab) {
      setActiveTab(tab);
    }
  };
  return (
    <div>
      <Header title="Booking" showSearch={false} icon={booking} >
        <div className="flex gap-2">
          <DateTimePicker />
          <Filter />
          <ReportButton />
          <CustomButton label="" icon={Plus} onClick={() => navigate('newbooking')} />
          <Notification />
        </div>
      </Header>
      <AdminCointainer>
        <div className="bg-white rounded-[20px] pt-2 ">
          <div className="flex justify-around p-4">
            {bookingStatus.map((status, index) => (
              <CountCard
                key={index}
                count={status.count}
                label={status.lable}
                backgroundColor={status.backgroundColor}
                textColor={status.textColor}
                className="w-[16%] gap-3 !text-[14px]"
              />
            ))}
          </div>


        </div>
        <br />
        <div>
          <CustomTabs
            tabs={bookingTabs}
            initialActiveTab="All Bookings"
            onTabChange={handleTabChange}
          />
        </div>
        <br />

        <div>{activeTab === "All Bookings" && <AllBooking />}</div>


        <div>{activeTab === "Pending" && (<>
          {/* <UnderConstruction /> */}
          {/* <LiveTracking /> */}
          {/* <SimpleLiveTrackingMap/> */}
        </>)}</div>
        <div>{activeTab === "Draft" && (<>
          <BookingDraft />
        </>)}</div>
        <div>{activeTab === "Completed" && (<>
          <UnderConstruction />
        </>)}</div>
        <div>{activeTab === "On Going" && (<>
          <UnderConstruction />
        </>)}</div>
        <div>{activeTab === "Holds" && (<>
          <UnderConstruction />
        </>)}</div>
        <div>{activeTab === "Clearance Points" && (<>
          <UnderConstruction />
        </>)}</div>
        <div>{activeTab === "Cancelled" && (<>
          <UnderConstruction />
        </>)}</div>



        <div>
          {activeTab === "Routes" && (
            <div>
              <div className="w-full max-w-4xl">
                <h1 className="text-2xl font-bold text-center mb-6">Live Status</h1>
                <Carousel items={items} autoScroll={false} scrollInterval={4000} />
              </div>

            </div>
          )}
        </div>

      </AdminCointainer>
    </div>
  );
};

export default Booking;
